let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("exMcy")).then(() => parcelRequire('8gBj2'));